import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class UserValidator {

    static userloginValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const forbidden = userLoginRegEx.test(control.value);
            return forbidden ? { userLoginRegEx: { value: control.value } } : null;
        };
    }
}

const userLoginRegEx: RegExp = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
// const userLoginRegEx: RegExp = /[\\|!"£$%&/()=?'^[\]+§°:;,{}]/;
// const userLoginRegEx: RegExp = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;